require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('ta-semantic-ui/semantic/dist/components/image.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/table.css');
require('ta-semantic-ui/semantic/dist/components/item.css');
require('ta-semantic-ui/semantic/dist/components/card.css');
require('styles/App.scss');

import React from 'react';
import Masthead from '@ta-interaktiv/react-polymorphic-masthead';
import Tracking from 'ta-react-polymorphic-tracking';
import StandaloneShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons';
import CopyrightNotice from 'ta-react-polymorphic-copyright-notice';
import ReactTooltip from 'react-tooltip';
import Waypoint  from 'react-waypoint';
import ArticleTeasers from '@ta-interaktiv/react-article-teasers';

class AppComponent extends React.Component {


  render() {
    return (
      <div className='index'>
        <Masthead inverted articleID='15125641' additionalFacebookShares={1136}/>

        <header className='ui inverted black vertical segment reduced-height'
                style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.5)), url(${require(
                    './img/cover/turkey.jpg')})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover'
                }}>
          <div className='header block'>
            <div className='ui container'>
              <h1 className='ui huge white header mobile hidden'>
                Unter<br/> Faschismus-Verdacht
              </h1>
              <h1 className='ui large white header mobile only'>
                Unter <br/>Faschismus-<br/>Verdacht
              </h1>
              <p className='ta lead'>Neue verbale Aggressivität in der Politik:
                Eine Analyse der Wortwahl und Sprachmuster von 17 Parteien.
              </p>
              </div>
          </div>
        </header>

        <div className='ui very fitted vertical segment white-bg' style={{
          paddingTop: '0'
        }}>
          <div className='ui container right aligned'>
            <p className='ta secondary caption' style={{paddingTop: '0.5ex'}}>
              Wolfsgruss: In Istanbul signalisieren türkische Nationalisten ihre
              Kampfbereitschaft. Foto: Carsten Koall (Getty)
            </p>
          </div>
        </div>

        <ReactTooltip />


        <div className='ui vertical infographic segment white-bg'>
          <div className='ui text container'>
            <p className='ta author'>Von Res Strehle und Interaktiv-Team<br />
            <span className='publish-date'>Publiziert: 18. März 2017</span></p>
            <p className='ta'>
              Der Historiker Carlo Moos verschränkt die Arme und überlegt. Wir
              sitzen in seinem kleinen Büro in der Forschungsstelle für Sozial-
              und Wirtschaftsgeschichte an der Universität Zürich. Hier unter
              der Dachschräge der alten Villa an der Rämistrasse ist das Stöckli
              für emeritierte Professoren. Neben Carlo Moos, dem Spezialisten
              für die Mussolini-Zeit, hat auch der 2015 emeritierte Jakob Tanner
              ein kleines Büro behalten. Beide betreuen sie noch eine Reihe von
              Doktoranden – auf so viel Wissen über die Zeitgeschichte des 20.
              Jahrhunderts verzichtet eine Universität nicht leichtfertig.
            </p>

            <Waypoint scrollableAncestor={window} onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'startReading'
                  }
                )
              }
            }}/>

            <p className='ta'>
              «Ja», sagt Carlo Moos schliesslich und fügt beinahe unhörbar an:
              «Es ist gefährlich.» Wir haben ihm die Frage gestellt, ob in der
              Welt ein neuer Faschismus drohe? Nachdem man diese Staatsform
              schon in die Geschichtsbücher verbannt hat? Bisher gibt es auf
              diese Frage nur leichtfertige Antworten: Auf der Rechten vermutet
              man den Faschismus bei den radikalen Islamisten. Den Faschismus am
              Rande rechtskonservativer Parteien hat sie mit dem deutschen
              Historiker Ernst Nolte in die Mottenkiste des 20. Jahrhunderts
              versorgt. Für die Linke hingegen ist ausgemacht, dass, wenn nicht
              Donald Trump, dann sein Chefberater Steve Bannon urfaschistische
              Denkmuster neu belebt; wenn nicht Marine Le Pen, dann ihr Vater
              Jean-Marie, der Parteigründer, und mit ihm ein grosser Teil der
              Basis des Front National; wenn nicht die gesamte Alternative für
              Deutschland (AfD), dann einzelne ihrer Exponenten wie Björn Höcke,
              teils bewusst, teils unbewusst. Und, ja, auch für einzelne
              SVP-Politiker am rechten Rand mag hier niemand die Hand ins Feuer
              legen.
            </p>

            <div className='quote'>
              <div className='person'>
                <div className='bild'
                     style={{backgroundImage: `url(${require('./img/moos.jpg')})`}}></div>
              </div>
              <div className='txt'>
                «Vieles, was wir heute sehen, ist nicht Faschismus, sondern
                autoritäre Oligarchie.»
                <div className='name'>Carlo Moos<br />Historiker, Zürich.</div>
              </div>
            </div>

            <p className='ta'>
              Zeit, den Faschismusverdacht zu klären – möglichst sachlich. Und
              wer wäre dazu hilfreicher als zwei andere Altmeister: Umberto Eco,
              der italienische Linguist und Schriftsteller, verstorben 2016, und
              Robert O. Paxton, der heute 84-jährige amerikanische Historiker,
              der 2004 sein Standardwerk «Anatomy of Fascism» veröffentlicht
              hatte, das zwei Jahre später auch auf Deutsch erschien.
            </p>
          </div>
        </div>


        <aside className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui stackable two column grid'>

              <div className='column'>
                <div className='ui basic vertical text segment '>
                  <p className='ta subheading'>Methodik</p>
                  <p className='ta'>Umberto Eco hat 14 urfaschistische
                    Sprachmuster definiert. Wir* haben 17 rechte und
                    konservative Parteien und ihre Rhetorik danach untersucht.
                    Die Anzahl erfüllter Kriterien soll klären, wie akut in den
                    Ländern die Gefahr eines neuen Faschismus ist.</p>
                </div>
              </div>

              <div className='column'>
                <div className='ui mobile only hidden divider'></div>
                <div className='explainer'>

                  <div className='half-width'>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/tradition.svg')})`
                           }}></div>
                      <div className='explain-text single-line'>Traditionskult
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/moderne.svg')})`
                           }}></div>
                      <div className='explain-text'>Gegen Aufklärung<br />und
                        Moderne
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/intellektuell.svg')})`
                           }}></div>
                      <div className='explain-text'>Misstrauen gegenüber<br />Intellektuellen
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/verrat.svg')})`
                           }}></div>
                      <div className='explain-text'>Sehen andere<br />Positionen
                        als Verrat
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/ueberfremdung.svg')})`
                           }}></div>
                      <div className='explain-text single-line'>Gegen
                        Überfremdung
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require('./img/frust.svg')})`
                           }}></div>
                      <div className='explain-text'>Appell an frustrierte<br />Mittelklasse
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/national.svg')})`
                           }}></div>
                      <div className='explain-text'>Nationalistische<br />Obsession
                      </div>
                    </div>
                  </div>

                  <div className='half-width'>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/feindbild.svg')})`
                           }}></div>
                      <div className='explain-text'>Widersprüchliches<br />Feindbild
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require('./img/kampf.svg')})`
                           }}></div>
                      <div className='explain-text'>Leben als Kampf,<br />gegen
                        Pazifismus
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/fuehrer.svg')})`
                           }}></div>
                      <div className='explain-text single-line'>Führerkult
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/heldenkult.svg')})`
                           }}></div>
                      <div className='explain-text single-line'>Heldenkult
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/machismo.svg')})`
                           }}></div>
                      <div className='explain-text'>Machismo<br />und Homophobie
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/vokabular.svg')})`
                           }}></div>
                      <div className='explain-text'>Krudes Vokabular<br />und
                        Syntax
                      </div>
                    </div>
                    <div>
                      <div className='explain-icon'
                           style={{
                             backgroundImage: `url(${require(
                               './img/gerichte.svg')})`
                           }}></div>
                      <div className='explain-text'>Gegen unabhängige<br />Gerichte
                      </div>
                    </div>
                  </div>


                </div>
              </div>


            </div>
          </div>
        </aside>


        <div className='ui vertical infographic segment white-bg'>
          <div className='ui container'>
            <div className='criteria-grid'>

              <h2>Wie nahe diese Parteien bei urfaschistischen Metaphern
                sind</h2>
              <div className='ta caption'>
                <div className='legend'>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/match_legend.svg')})`
                       }}></div>
                  <span>Sprachmuster erfüllt</span></div>
                <div className='legend'>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{backgroundImage: `url(${require('./img/none.svg')})`}}></div>
                  <span>Sprachmuster nicht erfüllt</span></div>
                <div className='legend'>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require('./img/unclear.svg')})`
                       }}></div>
                  <span>keine klare Aussage möglich</span></div>
                <div><i className='hand pointer icon'/>Um Sprachmuster zu sehen
                  auf Icons tippen
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>13<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/tur.svg')})`
                  }}></div>
                  <div className='party-text'>MHP</div>
                  <br />
                  <div className='leader-text'>D. Bahçeli</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require('./img/moderne.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{
                         backgroundImage: `url(${require(
                           './img/frust_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{backgroundImage: `url(${require('./img/kampf.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require('./img/fuehrer.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require('./img/heldenkult.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>

              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>12<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/de.svg')})`
                  }}></div>
                  <div className='party-text'>NPD</div>
                  <br />
                  <div className='leader-text'>F. Franz</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require('./img/moderne.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{
                         backgroundImage: `url(${require(
                           './img/frust_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require('./img/fuehrer.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require('./img/heldenkult.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>12<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/ch.svg')})`
                  }}></div>
                  <div className='party-text'>PNOS</div>
                  <br />
                  <div className='leader-text'>D. Lüthard</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require('./img/moderne.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{backgroundImage: `url(${require('./img/kampf.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require('./img/heldenkult.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require(
                           './img/machismo_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>11<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/hun.svg')})`
                  }}></div>
                  <div className='party-text'>Jobbik</div>
                  <br />
                  <div className='leader-text'>G. Vona</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require('./img/fuehrer.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require('./img/heldenkult.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require(
                           './img/gerichte_inactive.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>11<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/isr.svg')})`
                  }}></div>
                  <div className='party-text'>Nationalreligiöse</div>
                  <br />
                  <div className='leader-text'>N. Bennett</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require('./img/moderne.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{
                         backgroundImage: `url(${require(
                           './img/frust_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{backgroundImage: `url(${require('./img/kampf.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>10<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/usa.svg')})`
                  }}></div>
                  <div className='party-text'>Alt-Right</div>
                  <br />
                  <div className='leader-text'>R. Spencer</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require('./img/moderne.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require(
                           './img/verrat_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>10<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/rus.svg')})`
                  }}></div>
                  <div className='party-text'>LDPR</div>
                  <br />
                  <div className='leader-text'>W. Schirinowski</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require('./img/moderne.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require(
                           './img/national_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{backgroundImage: `url(${require('./img/kampf.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require(
                           './img/vokabular_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>9<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/isr.svg')})`
                  }}></div>
                  <div className='party-text'>Likud</div>
                  <br />
                  <div className='leader-text'>B. Netanjahu</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{
                         backgroundImage: `url(${require(
                           './img/frust_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{backgroundImage: `url(${require('./img/kampf.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require(
                           './img/machismo_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>9<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/aut.svg')})`
                  }}></div>
                  <div className='party-text'>FPÖ</div>
                  <br />
                  <div className='leader-text'>HC. Strache</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{
                         backgroundImage: `url(${require(
                           './img/frust_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require('./img/fuehrer.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require(
                           './img/machismo_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>9<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/rus.svg')})`
                  }}></div>
                  <div className='party-text'>Einiges Russland</div>
                  <br />
                  <div className='leader-text'>W. Putin</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require('./img/moderne.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require(
                           './img/feindbild_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{backgroundImage: `url(${require('./img/kampf.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require('./img/fuehrer.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require('./img/heldenkult.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require(
                           './img/vokabular_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require(
                           './img/gerichte_inactive.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>8<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/hun.svg')})`
                  }}></div>
                  <div className='party-text'>Fidesz</div>
                  <br />
                  <div className='leader-text'>V. Orbán</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require(
                           './img/feindbild_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{backgroundImage: `url(${require('./img/kampf.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require('./img/fuehrer.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require(
                           './img/machismo_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require(
                           './img/vokabular_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require(
                           './img/gerichte_inactive.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>8<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/de.svg')})`
                  }}></div>
                  <div className='party-text'>AfD</div>
                  <br />
                  <div className='leader-text'>F. Petry</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/tradition_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require('./img/moderne.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require(
                           './img/machismo_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>8<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/usa.svg')})`
                  }}></div>
                  <div className='party-text'>Republikaner</div>
                  <br />
                  <div className='leader-text'>Trump, Bannon</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require(
                           './img/verrat_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{
                         backgroundImage: `url(${require(
                           './img/frust_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{backgroundImage: `url(${require('./img/kampf.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require(
                           './img/machismo_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>8<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/tur.svg')})`
                  }}></div>
                  <div className='party-text'>AKP</div>
                  <br />
                  <div className='leader-text'>R.T. Erdogan</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/tradition_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{
                         backgroundImage: `url(${require(
                           './img/frust_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require('./img/fuehrer.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>

              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>7<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/ita.svg')})`
                  }}></div>
                  <div className='party-text'>Fratelli</div>
                  <br />
                  <div className='leader-text'>G. Meloni</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require('./img/tradition.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require(
                           './img/verrat_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require(
                           './img/feindbild_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require('./img/heldenkult.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require(
                           './img/machismo_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require(
                           './img/gerichte_inactive.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>7<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/ch.svg')})`
                  }}></div>
                  <div className='party-text'>SVP</div>
                  <br />
                  <div className='leader-text'>C. Blocher</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/tradition_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require('./img/national.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require(
                           './img/feindbild_unclear.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/heldenkult_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require(
                           './img/machismo_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require('./img/vokabular.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


              <div className='criteria-row'>
                <div className='party-column'>
                  <div className='score'>7<span>/14</span></div>
                  <div className='flag' style={{
                    backgroundImage: `url(${require('./img/ita.svg')})`
                  }}></div>
                  <div className='party-text'>PdL</div>
                  <br />
                  <div className='leader-text'>S. Berlusconi</div>
                </div>
                <div className='criteria-icons'>
                  <div className='criteria-icon'
                       data-tip='Traditionskult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/tradition_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Aufklärung und Moderne'
                       style={{
                         backgroundImage: `url(${require(
                           './img/moderne_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Misstrauen gegen Intellektuelle'
                       style={{
                         backgroundImage: `url(${require(
                           './img/intellektuell.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Sehen andere Position als Verrat'
                       style={{
                         backgroundImage: `url(${require('./img/verrat.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen Überfremdung'
                       style={{
                         backgroundImage: `url(${require(
                           './img/ueberfremdung_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Appell an frustrierte Mittelklasse'
                       style={{backgroundImage: `url(${require('./img/frust.svg')})`}}></div>
                  <div className='criteria-icon'
                       data-tip='Nationalistische Obsession'
                       style={{
                         backgroundImage: `url(${require(
                           './img/national_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Widersprüchliches Feindbild'
                       style={{
                         backgroundImage: `url(${require('./img/feindbild.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Leben als Kampf, gegen Pazifismus'
                       style={{
                         backgroundImage: `url(${require(
                           './img/kampf_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Führerkult'
                       style={{
                         backgroundImage: `url(${require(
                           './img/fuehrer_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Heldenkult'
                       style={{
                         backgroundImage: `url(${require('./img/heldenkult.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Machismo und Homophobie'
                       style={{
                         backgroundImage: `url(${require('./img/machismo.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Krudes Vokabular und Syntax'
                       style={{
                         backgroundImage: `url(${require(
                           './img/vokabular_inactive.svg')})`
                       }}></div>
                  <div className='criteria-icon'
                       data-tip='Gegen unabhängige Gerichte'
                       style={{
                         backgroundImage: `url(${require('./img/gerichte.svg')})`
                       }}></div>
                </div>
              </div>


            </div>
          </div>
        </div>

        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === 'below') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': '45ContentRead'
              }
            )
          }
        }}/>


        <div className='ui vertical infographic segment white-bg'>
          <div className='ui text container'>

            <p className='ta'>
              Beide Wissenschaftler gingen zeitlebens emotionslos ans Thema
              heran. Eco untersuchte als Strukturalist die Sprachmuster der
              frühen Faschisten in den verschiedenen Ländern und kam auf 14
              gemeinsame Elemente, die in den jeweiligen Situationen verwendet
              wurden und folglich für Urfaschismus stehen. Er veröffentlichte
              sie Mitte der Neunzigerjahre in seinen «Vier moralischen
              Schriften».
            </p>
            <p className='ta'>
              Laut Eco huldigen Faschisten überall dem Traditionskult, sie
              lehnen die Moderne ab und misstrauen kritischen Intellektuellen.
              Wer mit ihnen nicht übereinstimmt, gilt als Verräter und wird
              diffamiert. Stets appellieren sie gegen die drohende Überfremdung
              durch Einwanderer. Ziel ihrer Appelle ist insbesondere die
              frustrierte Mittel- und Unterschicht, die unter der Einwanderung
              am meisten zu leiden habe. Sie verwenden mit Vorliebe den Begriff
              «Volk», das sie für kollektiv halten und dem sie eine nationale
              Wiedergeburt in Aussicht stellen.
            </p>
            <p className='ta'>
              Alle orten sie einen Feind, der zugleich als zu stark (damit
              bedrohlich) aufgebaut wird, wie auch als zu schwach (damit
              besiegbar). Pazifismus und Gewaltfreiheit werden als weichsinnig
              abgelehnt. Man kritisiert die oppositionelle Elite, sieht sich
              zugleich aber selber als Elite und pflegt einen Heldenkult. Man
              überträgt den Willen zur Macht auf die Sexualität, versichert sich
              als Machismo der Gewissheit männlicher Überlegenheit und verachtet
              unkontrollierbare, «abartige» Formen der Sexualität wie Homo- oder
              Transsexualität. Ihr Wortschatz ist krude, der Satzaufbau einfach.
              Und schliesslich zweifeln alle Faschisten die Gewaltentrennung im
              Rechtsstaat an, mithin die Unabhängigkeit der drei anderen
              Gewalten: von Parlament, Gericht und Medien.
            </p>
            <p className='ta'>
              Vieles von dem, was Eco vor der Jahrtausendwende formulierte, wird
              einem heute bekannt vorkommen. Etwa wenn man nach Russland, Ungarn
              oder in die Türkei schaut, und auch in den USA sind seit dem
              Wahlkampf von Donald Trump einige dieser Denkmuster gang und gäbe.
              Das soll nicht zum vorschnellen Urteil führen, dort herrsche oder
              drohe Faschismus. Vielmehr soll die Anzahl erfüllter Kriterien von
              Ecos urfaschistischen Sprachmustern klären, wie akut in diesen
              Ländern die Gefahr eines neuen Faschismus ist. Dies ergibt einen
              ähnlichen, aber ebenso mit Vorsicht zu deutenden
              Gefährdungsraster, wie ihn der Zürcher Gerichtspsychiater Frank
              Urbaniok individuell für Gewalttäter erstellt hat. Wo ein
              Grossteil der Kriterien in seinem Raster («Fotres») erfüllt ist,
              muss man davon ausgehen, dass es für die Gesellschaft gefährlich
              werden kann. Dasselbe gilt für den Faschismus in weit grösserem
              Stil.
            </p>

            <p className='ta subheading'>Stufe um Stufe</p>
            <p className='ta'>
              Nun wird die Sprachanalyse der herrschenden Parteien und
              Bewegungen für sich allein nicht ausreichen, um zu beurteilen, ob
              einem Land Faschismus droht. Man muss diese Parteien und
              Bewegungen auch an ihren Taten messen. Aus der Geschichte ist
              bekannt, dass ein neuer Faschismus nicht über Nacht kommt, sondern
              sich in verschiedenen Stufen über die Jahre aufbaut. Laut dem
              erwähnten amerikanischen Historiker Paxton vollzieht sich der
              Übergang einer Demokratie zum Faschismus in insgesamt fünf Stufen:
              Am Anfang steht die Organisation der eigenen Bewegung zur Partei.
              Danach sucht die faschistische Bewegung auf Stufe 2 das Bündnis
              mit der alten Elite, weil sie für sich allein in einer Demokratie
              an der Urne nicht mehrheitsfähig ist (einzige Ausnahme war laut
              Paxton Schleswig-Holstein in der Zwischenkriegszeit).
            </p>
            <p className='ta'>
              Auf Stufe 3 übernimmt dieses Bündnis, in dem die Faschisten den
              dominierenden Part haben, die Macht. Gelingt dies, so wird auf
              Stufe 4 die Demokratie abgeschafft, der Gegner verfolgt und die
              Einparteienherrschaft etabliert. Auf Stufe 5 schliesslich wird die
              Opposition mit aller Härte unterdrückt und vernichtet, bis zur (in
              ihrer Dimension historisch einmaligen) Massenvernichtung im
              Nationalsozialismus.
            </p>
            <p className='ta'>
              Paxton warnt ausdrücklich vor der Vorstellung, die Abfolge dieser
              Stufen als Automatismus zu begreifen. Es ist laut ihm sehr wohl
              möglich, dass auf einer Stufe die Gegenkräfte genügend stark sind,
              dass die nächste nicht erreicht wird. Der emeritierte Historiker
              lebt nach langem Aufenthalt in Frankreich, wo er das Vichy-Regime
              untersuchte, inzwischen wieder in den USA.
            </p>


            <p className='ta subheading'>Trump auf Stufe 3</p>
            <p className='ta'>
              Auf Anfrage äussert sich Paxton mit gebotener Vorsicht. Er sieht
              die USA unter Präsident Donald Trump heute auf Stufe 3 seines
              Modells – wenn denn Trump und die Republikaner tatsächlich dem
              faschistischen Muster entsprechen. Dafür spricht aus seiner Sicht,
              dass Trump in seiner Wahlkampagne und seiner Taktik Muster
              bediente, die eng an jene des historischen Faschismus anlehnen:
              einen ausdrücklichen Nationalismus, die Angst vor dem Niedergang,
              die Verantwortung für diesen Niedergang bei Fremden und ethnischen
              Minderheiten, und als Rezept gegen den Niedergang die Mittel von
              Ausschluss und Gewalt.
            </p>
            <p className='ta'>
              Daneben sieht Paxton aber auch deutliche Unterschiede der
              Trump-Administration zum Faschismus: Dazu gehört insbesondere die
              Absicht, die Regulierungen zum Schutz von Umwelt und
              Arbeiterschaft stark abzubauen. Dieses Projekt ist in erster Linie
              ein Anliegen der Wirtschaft, aber Trump hat es übernommen. Dem
              entgegen hätten Hitler und Mussolini klar auf stärkere staatliche
              Regulierung gesetzt. Die beiden seien – auch dies ein wichtiger
              Unterschied zur Trump-Administration – in ihren Ländern von der
              alten Elite als Kraft gegen die Kommunisten eingesetzt worden,
              nachdem sie zuvor eigene paramilitärische Milizen aufgebaut
              hätten. Ohne wachsende kommunistische Parteien hält Paxton heute
              eine neue Bewegung von Braun- oder Schwarzhemden für
              unwahrscheinlich.
            </p>
            <p className='ta'>
              Insgesamt kommt der US-Historiker zum Schluss, dass die
              Trump-Administration auf Stufe 3 nicht als faschistisch bezeichnet
              werden darf, sondern als «autoritäre Plutokratie». «Das macht sie
              allerdings nicht weniger gefährlich», schreibt Paxton. Auch Carlo
              Moos bezeichnet die aktuellen Bedrohungen der Demokratie
              ausdrücklich nicht als faschistisch, sondern als
              «rechtspopulistisch-autoritär» oder allenfalls
              «postfaschistisch-nationalistisch». Zwar hat der Italienkenner
              selber einmal «eine gewisse Nähe» von Silvio Berlusconi zu Benito
              Mussolini postuliert, würde diese Aussage heute aber revidieren.
              Auch Beppe Grillo hält er für alles Mögliche, aber vor allem für
              einen «unberechenbaren Histrion», der in keiner Weise zu fixieren
              ist: «Grillo ist klar populistisch, aber nicht faschistisch.»
            </p>

            <p className='ta subheading'>Und die Schweiz?</p>
            <p className='ta'>
              Und wie siehts für die Schweiz aus? Wie gross sind hier die
              Risikofaktoren für Faschismus? Die wirtschaftliche Lage ist hier
              deutlich besser, der untere Mittelstand scheint im internationalen
              Vergleich stabil und – zumindest ausserhalb der Kommentarforen und
              sozialen Medien – wenig gekränkt. Entsprechend klein ist der
              Zulauf für Neonazis, auch die Rechtsaussenpartei Pnos ist im
              internationalen Vergleich eher klein. Aber daneben hat die SVP,
              taktisch stets offen auch gegenüber dem rechten politischen Rand,
              mit ihrem Appell gegen Überfremdung in den vergangenen Jahren
              stark zugelegt. Der Historiker Jakob Tanner, Spezialist für die
              moderne Schweizer Geschichte, weist darauf hin, dass sich die SVP
              gleich mehrerer der urfaschistischen Sprachmuster bedient.
              Gleichzeitig warnt er davor, den Faschismusverdacht leichtfertig
              zu äussern: «Wenn man mit Umberto Eco davon ausgeht, dass einzelne
              Kriterien Kristallisationspunkte für die anderen sind, dann stünde
              die ganze Schweiz mit ihrem Kult nationaler Helden und ihrer
              Überfremdungsangst seit ihrer Gründung unter Faschismusverdacht.»
            </p>
            <p className='ta'>
              Aber auch Tanner hält die gegenwärtige Lage für hochgefährlich:
              «Der unter dem Eindruck einer bedrohlichen Globalisierung
              entstandene neue Nationalismus erinnert an die Zeit vor dem Ersten
              Weltkrieg; er führte damals in die Katastrophe, aus welcher der
              Faschismus hervorging. Heute kommen Elemente aus der
              Zwischenkriegszeit dazu und die Umkehrung der Macht durch Big Data
              – nicht mehr das Volk kontrolliert seine Repräsentanten, sondern
              umgekehrt.
            </p>

            <div className='quote'>
              <div className='person'>
                <div className='bild'
                     style={{backgroundImage: `url(${require('./img/tanner.jpg')})`}}></div>
              </div>
              <div className='txt'>
                «Mit Ecos These stünde die ganze Schweiz unter
                Faschismus-Verdacht.»
                <div className='name'>Jakob Tanner<br />Historiker, Zürich.
                </div>
              </div>
            </div>

            <p className='ta'>
              Tanner trifft sich in diesem Urteil mit der Einschätzung der
              politischen Schweizer Philosophen Carlo Strenger und Georg Kohler.
              Strenger, der vor zwei Jahrzehnten nach Israel ausgewandert ist,
              sorgt sich nicht nur in seiner neuen Heimat über den Niedergang
              der Freiheitsrechte: «Wir sind unterwegs in Richtung illiberaler
              Demokratie.» Am deutlichsten hat von den ehemals demokratischen
              Gesellschaften die Türkei unter Recep Tayyip Erdogan die Grenze
              zwischen Demokratie und Faschismus überschritten. Georg Kohler
              teilt diese Einschätzung, das neue Ermächtigungsgesetz für
              Präsident Erdogan hält er für antirechtsstaatlich, antiliberal und
              antipluralistisch. Bei Trump-Berater Steve Bannon sieht der
              Liberale klassisch-faschistische Züge: «Mit solchen Leuten in
              Führungspositionen ist die Demokratie dabei, sich selber
              abzuschaffen. Es ist schon erstaunlich, dass einer in einem
              Rechtsstaat so weit kommt.»
            </p>


            <p className='ta subheading'>Nationale Revolution</p>
            <p className='ta'>
              Umso erstaunlicher ist die Sympathie für diese «demokratischen
              Revolten», wie der in Oxford lehrende Schweizer Historiker Oliver
              Zimmer den Brexit und den Sieg Donald Trumps bezeichnet. Auch der
              Walliser SVP-Regierungsrat Oskar Freysinger fordert eine
              «nationale Revolution». Die Alternative für Deutschland (AfD)
              schwelgt in ähnlichen Begriffen, Parteimitglied Björn Höcke träumt
              von einem «vollständigen Sieg der AfD» und einer tausendjährigen
              Zukunft Deutschlands. Er wirft den anderen Parteien eine
              «entartete» Politik vor, bezeichnet das Holocaust-Denkmal als
              «Denkmal der Schande» und spricht sich für eine 180-Grad-Wende der
              Erinnerungskultur aus. Gegen den drohenden Parteiausschluss
              verteidigte er sich im Nachrichtenmagazin «Spiegel» mit der
              Rechtfertigung emotionalen Überschwangs: «Da hatte sich was
              angestaut, das rausmusste.» Er neige in Reden eben dazu, die Dinge
              stark zu überzeichnen, meinte Höcke ausserdem.
            </p>
            <p className='ta'>
              Emotionalität schwingt laut der Sprachforscherin Elisabeth Wehling
              von der Universität Berkeley in der Begrifflichkeit stets mit und
              zeigt in diesem Fall das Framing. «Wir kennen den Sprachrahmen von
              Faschismus und anderen autoritären Gesellschaftsmodellen», sagt
              Wehling. «Vieles, was Trump oder Bannon sagen, speist sich genau
              aus diesem Frame.» Das lässt einen Weg in Richtung autoritäre
              Demokratie erwarten. Ob es gar in Richtung Neofaschismus geht,
              werden aber erst die nächsten Jahre zeigen. Ecos Kriterien für
              Urfaschismus finden sich laut Wehling in Trumps Rhetorik nahezu
              alle wieder. Offen ist aber, wie sich dieser Frame in Trumps
              politischem Handeln auswirkt und wie stark die Gegenseite darauf
              reagieren kann.
            </p>

            <div className='quote'>
              <div className='person'>
                <div className='bild'
                     style={{backgroundImage: `url(${require('./img/wehling.jpg')})`}}></div>
              </div>
              <div className='txt'>
                «Vieles, was Trump oder Bannon sagen, speist sich aus dem Frame
                des Faschismus.»
                <div className='name'>Elisabeth Wehling<br />Linguistin
                  Berkeley.
                </div>
              </div>
            </div>

            <p className='ta'>
              Im Mai wird sich Frankreichs Zukunft im zweiten Wahlgang der
              Präsidentschaftswahl klären. Der Sieg von Marine Le Pen scheint
              eher unwahrscheinlich, würde aber den urfaschistischen Diskurs
              auch in Europa ähnlich wie nach Trumps Sieg in den USA befeuern.
              Für den Historiker Carlo Moos greift in ihrem Fall die
              Qualifizierung als Faschistin zu kurz, richtig wäre die Einstufung
              als «nationalistische Rechtspopulistin». Näher beim Urfaschismus
              im Sinne von Umberto Eco sieht er ihre Nichte Marion Maréchal-Le
              Pen, die dem Grossvater offenkundig politisch näher verwandt sei
              als der Tante.
            </p>
            <p className='ta'>
              Carlo Strengers neues Buch «Abenteuer Freiheit» erinnert in jeder
              Zeile daran, Freiheit nicht für selbstverständlich zu halten,
              sondern sie stets aufs Neue zu erkämpfen. Timothy Snyder,
              Historiker an der Yale-Universität, gibt den Amerikanern nach
              Trumps Amtsantritt maximal ein Jahr Zeit, um diese Freiheit zu
              verteidigen – danach wären die demokratischen Institutionen durch
              den Umbau der Trump-Administration zu stark geschwächt. Georg
              Kohler sieht in dieser Auseinandersetzung die Wirtschaft als
              Verbündete gegen einen Übergang auf Stufe 4, denn «der Händler
              kann Gewalt nicht brauchen». Der Geschäftsmann Trump würde in
              dieser Hoffnung den Politiker Trump und seinen Berater Bannon
              mässigen.
            </p>


            <p className='ta subheading'>Die Flammenschrift an der Wand</p>
            <p className='ta'>
              Historiker Paxton erwartet noch vor Ende des ersten Amtsjahres der
              Administration Trump in den USA eine schwere Verfassungskrise.
              «Die Demokratie in den USA war schon vor Trumps Antritt
              geschwächt, weil beide Parteien die Macht der Exekutive ausgebaut
              hatten.» Paxton erwartet, dass Trump jene Bundesrichter, die gegen
              ihn entscheiden, auswechseln und versuchen wird, jene grossen
              Medien zu zerstören, die ihn ungnädig behandeln, wie die «New York
              Times» oder die «Washington Post». Ausserdem erwartet er
              aggressive aussenpolitische Schritte, um von innenpolitischen
              Misserfolgen abzulenken – das könnte Trump weitere
              Verfassungsklagen eintragen. Insgesamt resümiert der Altmeister
              unter den Faschismusforschern: «Die Fassade der Demokratie wird
              bleiben. Aber eine dauerhafte autoritäre Oligarchie scheint in den
              USA ein mögliches Ergebnis.»
            </p>
            <p className='ta'>
              Nächster Brennpunkt in der Auseinandersetzung zwischen liberaler
              und autoritärer Demokratie werden Ende April die Wahlen um die
              französische Staatspräsidentenschaft sein. Die beiden Historiker
              Moos und Paxton sind Frankreich stark zugeneigt. Paxton ist mit
              einer Französin verheiratet, seine Untersuchung zum Vichy-Regime
              löste im Land eine grosse Debatte über Kollaboration aus und wurde
              von Regisseur Claude Chabrol verfilmt («Das Auge von Vichy»). Moos
              und Paxton sind ausserdem beide Liebhaber klassischer Musik und
              treffen sich im Sommer regelmässig am Barockmusik-Festival von
              Beaune. Vergangenes Jahr wurde «Belsazar» von Georg Friedrich
              Händel aufgeführt: der Mythos des einstigen Königs von Babylon,
              der die unheilvollen Zeichen der Flammenschrift an der Wand im
              Übermut nicht zu deuten weiss. Die beiden befreundeten Historiker
              werden dieses Jahr in den Pausen viel zu reden haben.
            </p>

            <Waypoint scrollableAncestor={window} onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'contentBottom'
                  }
                )
              }
            }}/>

            <p className='ta note'>*Die Darstellung beruht auf Einschätzungen
              der aktuellen TA-Korrespondenten Oliver Meiler (zu Italien),
              Dominique Eigenmann (Deutschland), Sacha Batthyany (USA), der
              ehemaligen TA-Korrespondenten Bernhard Odehnal (zu Ungarn) und
              Zita Affentranger (Russland) sowie auf Gesprächen mit den
              politischen Historikern Jakob Tanner (zur Schweiz) und Carlo Moos
              (Italien, Frankreich) und den politischen Philosophen Georg Kohler
              (zur Türkei) und Carlo Strenger (Israel).</p>
          </div>
        </div>

        <aside className='ui vertical segment'>
          <div className='ui container'>
            <h2 className='ui small infographic dividing header'>Weitere Artikel
              zum Thema</h2>
            <ArticleTeasers numberOfCards='two' articleIds={['19118734']} style={{maxWidth: '100vw'}}/>
          </div>
        </aside>


        <div className='ui vertical inverted infographic segment'>
          <div className='ui container'>
            <div className='ui stackable two column aligned grid'>
              <div className='column'>
                <table className='ui definition inverted very basic table'>
                  <tbody>
                  <tr>
                    <td>Digitales Konzept & Umsetzung, Illustration:</td>
                    <td>Mathias Lutz und Marc Brupbacher, Interaktiv-Team</td>
                  </tr>
                  <tr className='desktop-only'>
                    <td colSpan='2'><CopyrightNotice inverted/></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className='column'>

                <table className='ui definition inverted very basic table'>
                  <tbody>
                  <tr>
                    <td><i className='comments icon'/></td>
                    <td>
                      <div className='content'>
                        <div className='header'> Haben Sie Anmerkungen oder
                          einen Fehler entdeckt?
                        </div>
                        <p>
                          <span>Wir freuen uns über Ihre </span>
                          <a href='mailto:interaktiv@tages-anzeiger.ch'>Nachricht</a>
                          <span>.</span>
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan='2'>
                      <div className='spacer'>&nbsp;</div>
                      <StandaloneShareButtons articleID='15125641'/>
                      <div className='spacer'>&nbsp;</div>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <Waypoint scrollableAncestor={window} onEnter={(event) => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'pageBottom'
                      }
                    )
                  }
                }}/>

              </div>

            </div>
          </div>
        </div>

        {
          //endregion
        }

        <Tracking articleId='15125641'/>

      </div>
    );
  }
}

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/main/Main.js